import { DEFAULT_PLATFORM_BRAND_ID } from '@today/brand-config/runtime'

/** `localStorage` key of the last fetched, compiled platform brand id (TO-541 REQ-102). */
export const PLATFORM_BRAND_STORAGE_KEY = 'today.platform-brand-id'

/**
 * The platform brand the app binds (TO-541 REQ-102): the fetched pointer, else the
 * last-known stored one, else the built-in default — each only when it is in the
 * compiled set, so the app never binds a brand it cannot render. Pure.
 */
export function resolvePlatformBrandId(
	fetched: string | null | undefined,
	stored: string | null,
	compiledIds: readonly string[],
): string {
	for (const candidate of [fetched, stored]) {
		if (candidate && compiledIds.includes(candidate)) return candidate
	}
	return DEFAULT_PLATFORM_BRAND_ID
}
